import { render, staticRenderFns } from "./YesbankUpi.vue?vue&type=template&id=5d71366e&scoped=true&"
import script from "./YesbankUpi.vue?vue&type=script&lang=js&"
export * from "./YesbankUpi.vue?vue&type=script&lang=js&"
import style0 from "./YesbankUpi.vue?vue&type=style&index=0&id=5d71366e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d71366e",
  null
  
)

export default component.exports